import { http } from '@/lib/apiClient';
import type { WorkflowDocumentType, WorkflowStepType } from '@/api/workflows.api';

export interface DashboardKpis {
  activeVendors: number;
  pendingApprovals: number;
  kycAttention: number;
  sapSyncHealthPercent: number;
}

export interface DashboardApprovalItem {
  taskId: string;
  instanceId: string;
  documentType: WorkflowDocumentType;
  documentId: string;
  documentNo: string | null;
  title: string;
  stepNo: number;
  stepType: WorkflowStepType;
  assignedRoleCode: string;
  createdAt: string;
}

export interface DashboardActivityItem {
  id: number;
  title: string;
  entityType: string;
  entityId: string;
  entityReference: string | null;
  action: string;
  severity: string;
  performedBy: string | null;
  performedByName: string | null;
  performedAt: string;
}

export interface SapSyncHealth {
  healthPercent: number;
  pendingOutbox: number;
  failedOutbox: number;
  successfulLogs24h: number;
  failedLogs24h: number;
}

export interface DashboardOverview {
  kpis: DashboardKpis;
  approvalQueue: DashboardApprovalItem[];
  recentActivity: DashboardActivityItem[];
  sapSyncHealth: SapSyncHealth;
}

export const dashboardApi = {
  overview: () => http.get<DashboardOverview>('/api/v1/dashboard/overview'),
};
